import { createAction, props } from '@ngrx/store';
import { Adressat, AdressatWithResource } from '../aufgabe.model';

const PREFIX = '[Adressat] ';

export const createAdressatAction = createAction(
	PREFIX + 'Create Adressat',
	props<{
		adressat: Adressat;
		kontaktId: number;
	}>()
);

export const updateAdressatChannelAction = createAction(
	PREFIX + 'Update Adressat Channel',
	props<{
		adressat: AdressatWithResource;
	}>()
);

export const updateAdressatNotizAction = createAction(
	PREFIX + 'Update Adressat Notiz',
	props<{
		adressat: AdressatWithResource;
	}>()
);

export const deleteAdressatAction = createAction(
	PREFIX + 'Delete Adressat',
	props<{
		adressat: AdressatWithResource;
	}>()
);
